import React, { useState, useEffect } from 'react';
import './Bonafide.css'
import NirgamDoc from './NirgamDoc';
import AlertMessage from "../../AlertMessage";
import {Link} from 'react-router-dom';

const NirgamReport = () => {
  const [formData, setFormData] = useState({
    stdName: '',
    stdMother: '',
    religion: '',
    class: '',
    educationalYear: '',
    dob: '',
    birthPlace: '',
    registerno: '',
    reason: '',
    selectedBookNo: '',
    progress: '',
    conduct: '',
    remark: '',
    schoolLogo: '',
    documentNo: '', // Initial document number
    bookno: '',
    printdate:'',
    date:'',
    dateOfAdmission: '', // Add this line
    studentId: '',
    panId: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [isStudentActive, setIsStudentActive] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const language = localStorage.getItem('language') || 'English';

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage(""); 
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);


  useEffect(() => {
    setFormData({
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      registerno: '',
      reason: language === 'English' ? 'Graduated' : 'इतरत्र जात आहे',
      selectedBookNo: '',
      progress: language === 'English' ? 'Excellent' : 'उत्कृष्ट',
      conduct: language === 'English' ? 'Excellent' : 'उत्कृष्ट',
      remark: language === 'English' ? 'Going Elsewhere' : 'इतरत्र जात आहे',
      schoolLogo: '',
      documentNo: '', // Initial document number
      bookno: '',
      printdate:'',
      date:'',
      dateOfAdmission: '', // Add this line
      studentId: '',
      panId: ''
    });
  }, [language]);
  const udiseNumber = localStorage.getItem("udiseNumber");
 

  const [duplicateStudents, setDuplicateStudents] = useState([]);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);

  const handleSelectStudent = (selectedStudent) => {
    setFormData((prevData) => ({
      ...prevData,
      stdName: selectedStudent.stdName || '',
      stdMother: selectedStudent.stdMother || '',
      religion: selectedStudent.religion || '',
      class: selectedStudent.currentClass || '',
      educationalYear: selectedStudent.educationalYear || '',
      dob: selectedStudent.dob || '',
      birthPlace: selectedStudent.birthPlace || '',
      dobInWords: selectedStudent.dobInWords || '',
      studentId: selectedStudent.studentId || '',
      panId: selectedStudent.panId || selectedStudent.penNo || '',
      stdSurname: selectedStudent.stdSurname || '',
      stdFather: selectedStudent.stdFather || '',
      stdAdharNo: selectedStudent.stdAdharNo || '',
      division: selectedStudent.division || '',
      bookno: selectedStudent.bookno || '',
      fOccupation: selectedStudent.fOccupation || '',
      motherTounge: selectedStudent.motherTounge || '',
      admissionClass: selectedStudent.admissionClass || '',
      dateOfAdmission: selectedStudent.dateOfAdmission || '' // Add this line
    }));
    setIsStudentActive(selectedStudent.isActive !== false);
    updateFormWithStudentData(selectedStudent);
    setShowDuplicatePopup(false);
  };

  const updateFormWithStudentData = (studentData) => {
    setFormData((prevData) => ({
      ...prevData,
      stdName: studentData.stdName || '',
      stdMother: studentData.stdMother || '',
      religion: studentData.religion || '',
      class: studentData.currentClass || '',
      educationalYear: studentData.educationalYear || '',
      dob: studentData.dob || '',
      birthPlace: studentData.birthPlace || '',
      dobInWords: studentData.dobInWords || '',
      studentId: studentData.studentId || '',
      panId: studentData.panId || studentData.penNo || '',
      stdSurname: studentData.stdSurname || '',
      stdFather: studentData.stdFather || '',
      stdAdharNo: studentData.stdAdharNo || '',
      caste: studentData.caste || '',
      prevSchool: studentData.prevSchool || '',
      dateOfAdmission: studentData.dateOfAdmission || '', // Add this line
      nationality: studentData.nationality || '',
      serialNo: studentData.serialNo || '',
      bookno: studentData.bookno || '',
      registerno: studentData.registerNo || '', // Make sure register number is updated
      division: studentData.division || '',
      fOccupation: studentData.fOccupation || '',
      motherTounge: studentData.motherTounge || '',
      admissionClass: studentData.admissionClass || '',
      progress: language === "English" ? "Excellent" : "उत्कृष्ट",
      conduct: language === "English" ? "Excellent" : "उत्कृष्ट",
      reason: language === "English" ? "Going Elsewhere" : "इतरत्र जात आहे",
      remark: language === "English" ? "Going Elsewhere" : "इतरत्र जात आहे",
    }));

    setSearchInput(`${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.trim());
  };
  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`; // Format date as yyyy-MM-dd
    setFormData(prevData => ({ ...prevData, printdate: formattedDate, date: formattedDate }));
  }, []);
  const clearFormData = () => {
    setFormData((prevData) => ({
      ...prevData,
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      dobInWords: '',
      studentId: '',
      panId: '',
      stdSurname: '',
      stdFather: '',
      stdAdharNo: '',
      caste: '',
      prevSchool: '',
      dateOfAdmission: '', // Add this line
      nationality: '',
      serialNo: '',
      bookno: '',
      registerno: '',
      division: '',
      fOccupation: '',
      motherTounge: '',
      admissionClass: '',
    }));
    setSearchInput('');
  };
  const handleChange = async (event) => {
    const { name, value } = event.target;
  
    // Update the form data for the input being changed
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (name === 'date' || name === 'printdate') {
      const date = new Date(value);
      const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`; // Format as yyyy-MM-dd
      setFormData((prevData) => ({ ...prevData, [name]: formattedDate }));
    }
    // Handle specific cases for stdName and registerno
    if (name === 'stdName') {
      setSearchInput(value);
      
      if (!value.trim()) {
        clearFormData();
        return;
      }

      try {
        const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

        request.onsuccess = async (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const studentRequest = objectStore.getAll(); // Fetch all student records

          studentRequest.onsuccess = async (event) => {
            const data = event.target.result;


        if (data && typeof data === 'object') {
          const matchingStudents = [];

          Object.values(data).forEach((studentData) => {
            if (studentData) {
              const fullName = `${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.toLowerCase();
              if (fullName.includes(value.toLowerCase())) {
                matchingStudents.push(studentData);
              }
            }
          });

          if (matchingStudents.length > 1) {
            setDuplicateStudents(matchingStudents);
            setShowDuplicatePopup(true);
          } else if (matchingStudents.length === 1) {
            updateFormWithStudentData(matchingStudents[0]);
            setIsStudentActive(matchingStudents[0].isActive !== false);
          }
        }
        
      };

      studentRequest.onerror = (event) => {
        console.error("Error fetching student data from IndexedDB:", event.target.error);
      };
    };

    
    
    
    request.onerror = (event) => {
      console.error("Error opening IndexedDB:", event.target.error);
    };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else if (name === 'registerno') {
      // Only clear form data if the input is empty
      if (!value.trim()) {
        clearFormData();
        return;
      }
  
      // Fetch matching students from IndexedDB
      try {
        const request = indexedDB.open('SchoolManagementDB', 1);
        request.onsuccess = async (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const studentRequest = objectStore.getAll();
  
          studentRequest.onsuccess = async (event) => {
            const data = event.target.result;
            if (data && typeof data === 'object') {
              const matchingStudents = [];
              Object.values(data).forEach((serialData) => {
                if (serialData && serialData.registerNo === value) {
                  matchingStudents.push(serialData);
                }
              });
  
                if (matchingStudents.length >= 1) {
                  const selectedStudent = matchingStudents.find(s => s.isActive !== false) || matchingStudents[0];
                  updateFormWithStudentData(selectedStudent);
                  setIsStudentActive(selectedStudent.isActive !== false);
                } else {
                  console.log('No matching student found for register number:', value);
                }
            }
          };
  
          studentRequest.onerror = (event) => {
            console.error("Error fetching student data from IndexedDB:", event.target.error);
          };
        };
  
        request.onerror = (event) => {
          console.error("Error opening IndexedDB:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const DuplicateStudentPopup = ({ duplicateStudents, onSelectStudent }) => {
    return (
      <div className="popup">
        <h4>{language === "English" ? "Select Student" : "विद्यार्थी निवडा"}</h4>
        <table className="student-table">
          <thead>
            <tr>
              <th>{language === "English" ? "Full Name" : "पूर्ण नाव"}</th>
              <th>{language === "English" ? "Class" : "वर्ग"}</th>
              <th>{language === "English" ? "Register No" : "नोंदणी क्र."}</th>
            </tr>
          </thead>
          <tbody>
            {duplicateStudents.map((student, index) => (
              <tr key={index} onClick={() => onSelectStudent(student)}>
                <td>{`${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`}</td>
                <td>{student.currentClass}</td>
                <td>{student.registerNo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // useEffect(() => {
  //   const fetchlastLeavDocNo = async () => {
  //     try {
  //       const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastLeavDocNo.json`);
  //       if (!response.ok) {
  //         throw new Error('Failed to fetch last document number');
  //       }
  //       const data = await response.json();
  //       setlastLeavDocNo(data || 0);
  //     } catch (error) {
  //       console.error('Error fetching last document number:', error);
  //     }
  //   };
  //   fetchlastLeavDocNo();
  // }, [udiseNumber]);



  // useEffect(() => {
  //   const today = new Date();
  //   const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`; // Format date as dd-mm-yyyy
  //   setFormData(prevData => ({ ...prevData, printdate: formattedDate, date: formattedDate }));
  // }, []);
  
  const [searchInput, setSearchInput] = useState('');

  const [isProgressOther, setIsProgressOther] = useState(formData.progress === (language === "English" ? "Other" : "इतर"));
  const [isConductOther, setIsConductOther] = useState(formData.conduct === (language === "English" ? "Other" : "इतर"));
  const [isReasonOther, setIsReasonOther] = useState(formData.reason === (language === "English" ? "Other" : "इतर"));
  const [isRemarkOther, setIsRemarkOther] = useState(formData.remark === (language === "English" ? "Other" : "इतर"));

  // Handle select change for each field
  const handleSelectChange = (event, field) => {
    const { name, value } = event.target;
    if (name === "progress") {
      setIsProgressOther(value === (language === "English" ? "Other" : "इतर"));
    } else if (name === "conduct") {
      setIsConductOther(value === (language === "English" ? "Other" : "इतर"));
    } else if (name === "reason") {
      setIsReasonOther(value === (language === "English" ? "Other" : "इतर"));
    } else if (name === "remark") {
      setIsRemarkOther(value === (language === "English" ? "Other" : "इतर"));
    }
    handleChange(event);
  };



  return (
    <div>
      {/* <Sidebar /> */}
    <AlertMessage message={alertMessage} show={showAlert}/>
      <div className='main-content-of-page leavingcer-hor-width Bonafide-Css' style={{ width: "90%", overflowX: "auto" }}>
        <div className='bonafidecontent '  >
          <h3 className='text-center mb-2' style={{ color:'#03365e', fontWeight:'600'}}>{language === "English" ? "Nirgam Report" : "निर्गम उतारा"} </h3>

          {!isStudentActive && (
                              <div className="alert alert-warning">
                                {language === "English" 
                                  ? "This student is inactive. Please activate the student to print the Nirgam Report." 
                                  : "हा विद्यार्थी निष्क्रिय आहे. निर्गम उतारा प्रिंट करण्यासाठी कृपया विद्यार्थ्याला सक्रिय करा."} 
                                <br/> <Link  to={`/student-register/?serialNo=${formData.serialNo}`}
                                                   >
                                                   {language === "English" ? "Edit Student Information" : "विद्यार्थी माहिती संपादित करा"}
                                                   </Link>
                              </div>
                            )}


          <div className="form-output">
            {/* <form onSubmit={handleSubmit}> */}
            <form >
              <br/>

              <div className="form-group l3">
                <label>{language === "English" ? "Register No " : "रजिस्टर क्र."}</label>
                <input style={{marginRight:'42px'}} className="input-field" type="text" name="registerno" value={formData.registerno} onChange={handleChange} required />
              </div>
              <br />
              <div className="form-group l3">
        <label>{language === "English" ? "Name " : "नाव"}</label>
        <input 
          style={{marginRight:'42px'}}  
          className="input-field" 
          type="text" 
          name="stdName"   
          value={searchInput}
          onChange={handleChange} 
          placeholder={language === "English" ? "Search by name..." : "नावाने शोधा..."}
          required 
        />
      </div>
              <br/>

              <div className="form-group l3">
                <label>{language === "English" ? "Class " : "वर्ग"}</label>
                <input style={{marginRight:'42px'}}  className="input-field" type="text" name="class" value={formData.class} onChange={handleChange} required />
              </div>
              {/* <br />

              <div className="form-group l3">
                <label>{language === "English" ? "Date of Admission " : "प्रवेशाची तारीख"}</label>
                <input style={{marginRight:'42px'}}  className="input-field" type="date" name="dateOfAdmission" value={formData.dateOfAdmission} onChange={handleChange} required />
              </div> */}
              <br />

              

      <br />

      <div className="form-group l1">
    <label>{language === "English" ? "Conduct" : "दोन चिन्ह"}</label>
    <select
        className="input-field"
        name="conduct"
        value={isConductOther ? "Other" : formData.conduct} // Keep "Other" selected if the input is active
        onChange={(e) => handleSelectChange(e, "conduct")}
        required
    >
        <option value={language === "English" ? "Excellent" : "उत्कृष्ट"}>
            {language === "English" ? "Excellent" : "उत्कृष्ट"}
        </option>
        <option value={language === "English" ? "Good" : "चांगले"}>
            {language === "English" ? "Good" : "चांगले"}
        </option>
        <option value={language === "English" ? "Satisfactory" : "समाधानकारक"}>
            {language === "English" ? "Satisfactory" : "समाधानकारक"}
        </option>
        <option value={language === "English" ? "Other" : "इतर"}>
            {language === "English" ? "Other" : "इतर"}
        </option>
    </select>

    {isConductOther && (
        <div style={{ marginTop: '10px', marginLeft: '105px', width: '420px' }}>
            <input
                className="input-field"
                name="conduct"
                value={formData.conduct}
                onChange={(e) => {
                    handleChange(e);
                    if (e.target.value === "") {
                        setIsConductOther(false); // Revert to "Other" if input is cleared
                    }
                }}
            />
        </div>
    )}
</div>

      <br />

      <div className="form-group l1">
    <label>{language === "English" ? "Reason" : "कारण"}</label>
    <select
        className="input-field"
        name="reason"
        value={isReasonOther ? "Other" : formData.reason} // Keep "Other" selected if the input is active
        onChange={(e) => handleSelectChange(e, "reason")}
        required
    >
        <option value={language === "English" ? "Graduated" : "पदवी प्राप्त केली"}>
            {language === "English" ? "Graduated" : "पदवी प्राप्त केली"}
        </option>
        <option value={language === "English" ? "Transferred" : "हस्तांतरित"}>
            {language === "English" ? "Transferred" : "हस्तांतरित"}
        </option>
        <option value={language === "English" ? "Expelled" : "निष्कासित"}>
            {language === "English" ? "Expelled" : "निष्कासित"}
        </option>
        <option value={language === "English" ? "Other" : "इतर"}>
            {language === "English" ? "Other" : "इतर"}
        </option>
    </select>

    {isReasonOther && (
        <div style={{ marginTop: '10px', marginLeft: '105px', width: '420px' }}>
            <input
                className="input-field"
                name="reason"
                value={formData.reason}
                onChange={(e) => {
                    handleChange(e);
                    if (e.target.value === "") {
                        setIsReasonOther(false); // Revert to "Other" if input is cleared
                    }
                }}
            />
        </div>
    )}
</div>
<br />

      <div className="form-group l1">
    <label>{language === "English" ? "Remark" : "विवरण"}</label>
    <select
        className="input-field"
        name="remark"
        value={isRemarkOther ? "Other" : formData.remark} // Keep "Other" selected if the input is active
        onChange={(e) => handleSelectChange(e, "remark")}
        required
    >
        <option value={language === "English" ? "Going Elsewhere" : "इतरत्र जात आहे"}>
            {language === "English" ? "Going Elsewhere" : "इतरत्र जात आहे"}
        </option>
        <option value={language === "English" ? "Transferred" : "हस्तांतरित"}>
            {language === "English" ? "Transferred" : "हस्तांतरित"}
        </option>
        <option value={language === "English" ? "Expelled" : "निष्कासित"}>
            {language === "English" ? "Expelled" : "निष्कासित"}
        </option>
        <option value={language === "English" ? "Other" : "इतर"}>
            {language === "English" ? "Other" : "इतर"}
        </option>
    </select>

    {isRemarkOther && (
        <div style={{ marginTop: '10px', marginLeft: '105px', width: '420px' }}>
            <input
                className="input-field"
                name="remark"
                value={formData.remark}
                onChange={(e) => {
                    handleChange(e);
                    if (e.target.value === "") {
                        setIsRemarkOther(false); // Revert to "Other" if input is cleared
                    }
                }}
            />
        </div>
    )}
</div>

              <br />

              <div className="form-group mb-3">
  <label style={{flex: 'none'}}>{language === "English" ? " Nirgam Date " : "निर्गम तारीख "}</label>
  <input  className="input-field dt-lc" style={{width:'200px', marginLeft:'50px'}}  type="date" name="date"  value={formData.date}  onChange={handleChange}  required
  />
</div>
<div className="form-group">
      <label style={{ flex: 'none' }}>
        {language === "English" ? "Certificate Print Date " : "निर्गम प्रिंट तारीख"}
      </label>
      <input
        className="input-field dt-lc"
        style={{ width: '200px', marginLeft: '20px' }}
        type="date"
        name="printdate"
        value={formData.printdate}
        onChange={handleChange}
        required
      />
    </div>
            </form>
          </div>

          {showDuplicatePopup && (
            <div className="popup-container">             
                <DuplicateStudentPopup
                  duplicateStudents={duplicateStudents}
                  onSelectStudent={handleSelectStudent}
                />
            </div>
          )}
        </div>
        <div className='leavedoc-doic' >
          <NirgamDoc 
            submitted={submitted}
            formData={formData}  isStudentActive={isStudentActive}
          />
        </div>
      </div>
    </div>
  );
};

export default NirgamReport;